export default "../../../static/plugins/visualizations/nora/static/assets/fontawesome-webfont.db812d8a70a4e88e888744c1c9a27e89.woff2";